/**
 * Add a performance.mark() entry, if the Performance API is available.
 */
export var mark = function mark(name) {
  var _window$performance;

  if (!((_window$performance = window.performance) !== null && _window$performance !== void 0 && _window$performance.mark)) {
    return;
  }

  window.performance.mark(name);
};
/**
 * Add a performance.measure() entry, if the Performance API is available.
 */

export var measure = function measure() {
  var _window$performance2, _window$performance3;

  if (!((_window$performance2 = window.performance) !== null && _window$performance2 !== void 0 && _window$performance2.measure)) {
    return;
  }

  (_window$performance3 = window.performance).measure.apply(_window$performance3, arguments);
};